import { Component, h, Prop } from '@stencil/core';
import { UserType } from '@ugc-components/ugc-pdp-question-and-answer/interfaces';
import state from '@ugc-store';

@Component({
  tag: 'ugc-answer-sign',
  shadow: false,
})
export class UgcAnswerSign {
  @Prop() userType: UserType = UserType.Customer;

  render() {
    const {
      qnaStaticLanguage: { IDS_UGC_QNA_CUSTOMER_SERVICE, IDS_UGC_QNA_BRAND },
    } = state;

    const isShowUserSign = this.userType === UserType.CustomerService || this.userType === UserType.Vendor;

    // render customer sign
    const renderCustomerSign = this.userType === UserType.CustomerService && (
      <span class="bold ft-12 px-8 rounded-16 color-white bg-green-standard">{IDS_UGC_QNA_CUSTOMER_SERVICE}</span>
    );
    // render brand sign
    const renderBrandSign = this.userType === UserType.Vendor && (
      <span class="bold ft-12 px-8 rounded-16 color-white bg-orange-standard">{IDS_UGC_QNA_BRAND}</span>
    );
    if (!isShowUserSign) return null;
    return (
      <div class="flex-row-start-center">
        {renderCustomerSign}
        {renderBrandSign}
      </div>
    );
  }
}
